import { createSimpleFunctional } from '../../utils/helpers'

export { default as List } from './list'
export { default as ListGroup } from './list-group'
export { default as ListTile } from './list-tile'
export { default as ListTileAction } from './list-tile-action'

export const ListItem = createSimpleFunctional('list__item', 'li')
export const ListSubheader = createSimpleFunctional('list__subheader', 'li')
export const ListDivider = createSimpleFunctional('list__divider', 'hr')
export const ListTileActionText = createSimpleFunctional('list__tile__action-text', 'span')
export const ListTileContent = createSimpleFunctional('list__tile__content', 'div')
export const ListTileTitle = createSimpleFunctional('list__tile__title', 'div')
export const ListTileSubTitle = createSimpleFunctional('list__tile__sub-title', 'div')